import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Modal } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';
import { TransactionList } from './TransactionList';
import { IAdminTransaction } from '@/types/admin/transactions';

interface TransactionHistoryModalProps {
  visible: boolean;
  onClose: () => void;
  transactions: IAdminTransaction[];
  residentName?: string;
}

export const TransactionHistoryModal: React.FC<TransactionHistoryModalProps> = ({
  visible,
  onClose,
  transactions,
  residentName,
}) => {
  return (
    <Modal
      visible={visible}
      animationType="slide"
      presentationStyle="pageSheet"
      onRequestClose={onClose}
    >
      <View style={styles.container}>
        {/* Header */}
        <View style={styles.header}>
          <View style={styles.headerContent}>
            <Text style={styles.title}>Transaction History</Text>
            {residentName && (
              <Text style={styles.subtitle}>{residentName}</Text>
            )}
          </View>
          <TouchableOpacity 
            style={styles.closeButton}
            onPress={onClose}
          >
            <Text style={styles.closeButtonText}>✕</Text>
          </TouchableOpacity>
        </View>

        {/* Transaction List - Direct FlatList, no ScrollView wrapper */}
        {transactions.length === 0 ? (
          <View style={styles.emptyState}>
            <Text style={styles.emptyText}>
              No transactions found for this resident.
            </Text>
          </View>
        ) : (
          <View style={styles.listContainer}>
            <TransactionList 
              transactions={transactions}
              maxRows={0} // 0 = show all transactions (virtualized via FlatList)
            />
          </View>
        )}
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: ADMIN_COLORS.BACKGROUND.PRIMARY,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    paddingHorizontal: 20,
    paddingTop: 20,
    paddingBottom: 16,
    borderBottomWidth: 1,
    borderBottomColor: ADMIN_COLORS.BORDER,
    backgroundColor: ADMIN_COLORS.SURFACE,
  },
  headerContent: {
    flex: 1,
  },
  title: {
    fontSize: 24,
    fontWeight: '700',
    color: ADMIN_COLORS.TEXT_PRIMARY,
    marginBottom: 4,
  },
  subtitle: {
    fontSize: 14,
    color: ADMIN_COLORS.TEXT_SECONDARY,
  },
  closeButton: {
    width: 32,
    height: 32,
    borderRadius: 16,
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 12,
  },
  closeButtonText: {
    fontSize: 20,
    color: ADMIN_COLORS.TEXT_PRIMARY,
    fontWeight: '600',
  },
  listContainer: {
    flex: 1,
    padding: 16,
  },
  emptyState: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 60,
  },
  emptyText: {
    fontSize: 16,
    color: ADMIN_COLORS.TEXT_SECONDARY,
    textAlign: 'center',
  },
});

